import type { BuyerLicense } from '@/models/company';
import type { OrderSummaryOrder } from '@/models/order';
import type { AttachedPackageBase } from '@/models/traceability';

export interface AttachPackageRequest {
  externStsId: number | string;
  orderedProduct: number;
  packageTagNumber: string;
  quantity: string;
  unitOfMeasure: string | number | null;
}

export interface AttachedPackagesResponse extends AttachedPackageBase {
  externStsId: string | number;
}

export enum TraceabilityPackageStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  OnHold = 'OnHold',
}

export type TraceabilityPackageStatuses = `${TraceabilityPackageStatus}`;

export interface TraceabilityTemplateData {
  licenseNumber: string;
  destinationCompanyId: number;
  transferTypeId: number;
  estimatedDeparture: string;
  estimatedArrival: string;
}

export enum DateFilter {
  ArrivalDate = 'arrivalDate',
  ShipDate = 'shipDate',
}

export type DateFilters = `${DateFilter}`;

export enum SeedToSaleVendor {
  BioTrack = 'BioTrack',
  Metrc = 'METRC',
}

export type SeedToSaleVendors = `${SeedToSaleVendor}`;

export enum RefreshType {
  InTransit = 'in_transit',
  Item = 'item',
  Location = 'location',
  Package = 'package',
  Transfer = 'transfer',
}

export type RefreshTypes = `${RefreshType}`;

export interface RefreshResourcesRequestParams {
  endDate?: string;
  startDate?: string;
  types: RefreshTypes[];
}

export enum RefreshRequestStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  FailedConfigError = 'FAILED_CONFIG_ERROR',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type RefreshRequestStatuses = `${RefreshRequestStatus}`;

export type ManifestMatchesForOrders = Record<string, boolean>;

export interface SuggestedManifestRequest {
  ll_order_id: OrderSummaryOrder['id'];
  buyer_license_numbers: BuyerLicense['number'][];
  line_item_product_ids: number[];
}

export interface MetrcAttachedManifestsRequest {
  orderNumber: OrderSummaryOrder['number'];
  transferType?: 'outbound' | 'inbound' | 'pending';
}
